import type { ReactNode } from "react";

interface CalloutProps {
  children: ReactNode;
  /**
   * Drop the blue accent rail for a plain tinted panel. The surface colour and
   * padding stay; only the left border goes.
   *
   * For a callout that isn't flagging anything — a totals row, a summary line —
   * the rail reads as a status marker that means nothing, and at a glance the
   * block gets mistaken for a Banner.
   */
  hideAccent?: boolean;
}

export function Callout({ children, hideAccent }: CalloutProps) {
  return (
    // The rail's classes stay in their original position rather than being
    // appended, so a default Callout renders the exact class string it always
    // has and no existing snapshot churns.
    <div
      className={`rounded-lg ${
        hideAccent ? "" : "border-l-4 border-blue "
      }bg-light-background px-4 py-3`}
    >
      {children}
    </div>
  );
}
